module.exports = __webpack_public_path__ + "assets-cabinet/img/pin-icon.99328597.svg";